import posthog from "posthog-js";

const POSTHOG_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST;

export const initPostHog = () => {
  if (typeof window !== "undefined" && POSTHOG_KEY) {
    posthog.init(POSTHOG_KEY, {
      api_host: POSTHOG_HOST || "https://app.posthog.com",
      person_profiles: "identified_only",
      capture_pageview: false, // We'll manually capture pageviews
      capture_pageleave: true,
      session_recording: {
        recordCrossOriginIframes: true,
        maskAllInputs: false,
        maskInputOptions: {
          password: true,
        },
      },
      loaded: (posthog) => {
        if (import.meta.env.DEV) posthog.debug();
      },
    });
  }
};

export const identifyUser = (userId: string, traits?: Record<string, any>) => {
  if (typeof window !== "undefined" && posthog) {
    posthog.identify(userId, traits);
  }
};

export const trackEvent = (
  eventName: string,
  properties?: Record<string, any>
) => {
  if (typeof window !== "undefined" && posthog) {
    posthog.capture(eventName, properties);
  }
};

export const trackPageView = (pageName?: string) => {
  if (typeof window !== "undefined" && posthog) {
    posthog.capture("$pageview", {
      $current_url: window.location.href,
      page_name: pageName,
    });
  }
};

export const resetUser = () => {
  if (typeof window !== "undefined" && posthog) {
    posthog.reset();
  }
};

/**
 * Report an exception to PostHog so it shows up as an `$exception` event on the
 * session-replay timeline. Used by the global error boundary — React render
 * crashes were previously invisible in PostHog (they only reached Sentry), which
 * made session replays impossible to diagnose without the stack trace.
 */
export const captureException = (
  error: unknown,
  additionalProperties?: Record<string, any>
) => {
  if (
    typeof window !== "undefined" &&
    posthog &&
    typeof posthog.captureException === "function"
  ) {
    posthog.captureException(error, additionalProperties);
  }
};

export { posthog };
